import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { Helmet } from 'react-helmet';

import { RootState } from '../../../ducks/store';
import { clearReportData, getCLEReportData } from '../../../ducks/report';
import PageHeader from '../../common/PageHeader/PageHeader';
import Report from '../../common/Report/Report';

import './CLEReport.scss';

const getLastMonthDates = () => {
  const today = new Date();
  const month = today.getMonth();
  const firstLastMonth = new Date();
  firstLastMonth.setMonth(month - 1);
  firstLastMonth.setDate(1);

  const lastLastMonth = new Date();
  lastLastMonth.setDate(0);
  return [firstLastMonth, lastLastMonth];
};

const CLEReport = () => {
  const dispatch = useDispatch();
  const { reportData, user } = useSelector((state: RootState) => {
    return {
      reportData: state.report.data,
      user: state.auth.authenticatedUser,
    };
  });

  const [firstLastMonth, lastLastMonth] = getLastMonthDates();
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState<Date | null>(firstLastMonth);
  const [toDate, setToDate] = useState<Date | null>(lastLastMonth);

  useEffect(() => {
    dispatch(getCLEReportData(firstLastMonth, lastLastMonth));
    return () => {
      dispatch(clearReportData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (reportData) {
      setLoading(false);
    }
  }, [reportData]);

  const onDateRangeChange = (dates: [Date | null, Date | null]) => {
    const [from, to] = dates;
    setFromDate(from);
    setToDate(to);

    if (from && to) {
      dispatch(getCLEReportData(from, to));
    }
  };

  return (
    <div className="CLEReport d-flex flex-column">
      <Helmet>
        <title>CLE Report - Praktio</title>
      </Helmet>
      {/* Passing mb-0 to properly display overlayspinner */}
      <PageHeader pageName="CLE Report" className="mb-0">
        <div>Date Range</div>
        <DatePicker
          selected={fromDate}
          onChange={onDateRangeChange}
          startDate={fromDate}
          endDate={toDate}
          placeholderText="No date range selected."
          selectsRange
        />
      </PageHeader>
      <Report user={user} reportData={reportData} loading={loading} isCLE />
    </div>
  );
};

export default CLEReport;
